import { IkasMerchantSettings } from ".";

export function initIkasMerchantSettings(settings: IkasMerchantSettings) {
  settings.logo = settings.logoId
    ? { id: settings.logoId, isVideo: false }
    : null;
}
